import _from from './from';
import _to from './to';

export type { Types as RSTypes } from './types';

export class RSMap {
  static to   = _to;
  static from = _from;
}
